<div class="card">
    <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
            <h2 class="text-xl font-semibold m-0">App Settings</h2>
            <p class="text-sm text-muted-color mt-1 mb-0">
                Configure conditions that determine whether a rate is shown on the web (`is_shown_on_web`).
            </p>
        </div>

        @if (canEdit) {
            <div class="flex gap-2">
                <p-button label="Add condition"
                          icon="pi pi-plus"
                          severity="secondary"
                          [disabled]="loading || saving || syncInProgress"
                          (onClick)="addRule()"/>
                <p-button label="Save"
                          icon="pi pi-save"
                          [loading]="saving"
                          [disabled]="loading || syncInProgress"
                          (onClick)="save()"/>
            </div>
        }
    </div>

    @if (syncInProgress && activeSyncStatus) {
        <div class="flex items-start gap-3 mb-4 p-3 text-sm border border-sky-200 rounded-lg bg-sky-50">
            <i class="pi pi-spin pi-spinner mt-0.5" aria-hidden="true"></i>
            <span>{{ activeSyncStatus.message }}</span>
        </div>
    }

    @if (loading) {
        <p class="text-muted-color">Loading rules...</p>
    } @else if (rules.length === 0) {
        <p class="text-muted-color">No visibility conditions configured.</p>
    } @else {
        <p-table [value]="rules" responsiveLayout="scroll" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 14rem">Label</th>
                    <th style="width: 12rem">Field Key</th>
                    <th style="width: 12rem">Operator</th>
                    <th style="width: 10rem">Type</th>
                    <th>Values</th>
                    <th style="width: 6rem">Active</th>
                    @if (canEdit) {
                        <th style="width: 4rem"></th>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rule let-rowIndex="rowIndex">
                <tr>
                    <td>
                        <input pInputText
                               class="w-full"
                               [(ngModel)]="rule.label"
                               [disabled]="!canEdit"
                               placeholder="Display label"/>
                    </td>
                    <td>
                        <input pInputText
                               class="w-full"
                               [(ngModel)]="rule.field_key"
                               [disabled]="!canEdit"
                               placeholder="e.g. district_name"/>
                    </td>
                    <td>
                        <p-select [options]="operatorOptions"
                                  [(ngModel)]="rule.operator"
                                  (ngModelChange)="onOperatorChange(rule, $event)"
                                  optionLabel="label"
                                  optionValue="value"
                                  [disabled]="!canEdit"
                                  appendTo="body"
                                  class="w-full"/>
                    </td>
                    <td>
                        <p-select [options]="valueInputTypeOptions"
                                  [(ngModel)]="rule.value_input_type"
                                  (ngModelChange)="onValueInputTypeChange(rule)"
                                  optionLabel="label"
                                  optionValue="value"
                                  [disabled]="!canEdit"
                                  appendTo="body"
                                  class="w-full"/>
                    </td>
                    <td>
                        <app-condition-value-input
                            [autocompleteField]="rule.autocomplete_field ?? rule.field_key"
                            [valueInputType]="rule.value_input_type ?? 'text'"
                            [values]="rule.values ?? []"
                            [disabled]="!canEdit"
                            (valuesChange)="rule.values = $event"/>
                    </td>
                    <td class="text-center">
                        <p-checkbox [(ngModel)]="rule.is_active"
                                    [binary]="true"
                                    [disabled]="!canEdit"/>
                    </td>
                    @if (canEdit) {
                        <td>
                            <p-button icon="pi pi-trash"
                                      severity="danger"
                                      [text]="true"
                                      pTooltip="Remove condition"
                                      (onClick)="removeRule(rowIndex)"/>
                        </td>
                    }
                </tr>
            </ng-template>
        </p-table>
    }
</div>
